__turbopack_context__.v({
  "button": "Buttton-module-scss-module__wDr4Vq__button",
});
